
import React from 'react'
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
  xlinkHref: string,
  className?: string,
  style?: unknown,
  viewBox?: string,
  onClick?: (() => void)
}

export default function GSSVG(props: Props): React.ReactElement {
  const { xlinkHref, className, viewBox, onClick, style } = props
  return (
    <SvgIcon
      data-testid='gssvg'
      className={className}
      onClick={onClick}
      style={style}
      viewBox={viewBox}>
      <use
        xmlnsXlink='http://www.w3.org/1999/xlink'
        xlinkHref={xlinkHref}
      />
    </SvgIcon>
  )
}
